const digitRegExp = /[0-9]/;

export function OnlyNumberMask(value) {
  const arr = value.split('').map(char => {
    if (digitRegExp.test(char)) {
      return digitRegExp;
    }
  });

  return arr;
}
